import { createSelector } from '@ngrx/store';

import { selectLoggedUser } from '../../../auth/auth.selectors';
import { selectCountryCardsState } from '../../../core.state';
import { getRouterInfo } from '../../../router/router.selector';
import { Utils } from '../../../utils/utils';

export const selectCountryCards = createSelector(
    selectCountryCardsState,
    (state) => {
        const list = [...state.countryCardList].sort((c1, c2) => Utils.sort(c1.country.name, c2.country.name, true));
        return list;
    }
);

export const selectCountryCardsLoaded = createSelector(
    selectCountryCardsState,
    (state) => state.loaded
);

export const selectCountryCardsCompanyId = createSelector(
    selectLoggedUser,
    getRouterInfo,
    (loggedUser, routerInfo) => (
        routerInfo.params.companyId ? routerInfo.params.companyId :
            (routerInfo.queryParams.companyId ? routerInfo.queryParams.companyId : loggedUser.company.id))
);
